import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { getContent } from "@/lib/api";

export default function Footer() {
  const [contact, setContact] = useState(null);

  useEffect(() => {
    getContent()
      .then((c) => setContact(c.contact))
      .catch(() => {});
  }, []);

  return (
    <footer className="border-t border-white/10 bg-[#070707]" data-testid="site-footer">
      <div className="grid gap-12 px-6 py-16 md:grid-cols-12 md:px-12 md:py-20 lg:px-20">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <img src="/logo-mark.png" alt="Catalyst Petrochem logo" className="h-10 w-auto" />
            <span className="font-display text-xl font-bold uppercase tracking-tight">
              Catalyst <span className="text-brand">Petrochem</span>
            </span>
          </div>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-neutral-500">
            One of India's leading bitumen importers — sourcing premium paving-grade binders from the Middle East and
            delivering certified supply to highways, industries and infrastructure across the nation.
          </p>
          <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-600">Thriving the world</p>
        </div>
        <div className="md:col-span-2">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-600">Explore</p>
          <ul className="mt-5 space-y-3 text-sm">
            {[["About", "/about"], ["Products", "/products"], ["Achievements", "/achievements"], ["Certifications", "/certifications"], ["Infrastructure", "/infrastructure"], ["News", "/news"], ["Contact", "/contact"]].map(([label, to]) => (
              <li key={to}>
                <Link to={to} data-testid={`footer-link-${label.toLowerCase()}`} className="text-neutral-400 transition-colors hover:text-brand">
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-2">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-600">Flagship Grades</p>
          <ul className="mt-5 space-y-3 text-sm">
            {[["Bitumen VG-30", "/products/bitumen-vg-30"], ["Bitumen VG-40", "/products/bitumen-vg-40"], ["PMB", "/products/polymer-modified-bitumen"], ["CRMB", "/products/crumb-rubber-modified-bitumen"], ["Emulsion", "/products/bitumen-emulsion"], ["Cold Mix", "/products/cold-mix"]].map(([label, to]) => (
              <li key={to}>
                <Link to={to} className="text-neutral-400 transition-colors hover:text-brand">
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-600">Head Office</p>
          {contact && (
            <div className="mt-5 space-y-3 text-sm text-neutral-400">
              <p className="leading-relaxed">{contact.address}</p>
              {contact.phones.map((p) => (
                <p key={p}>
                  <a href={`tel:${p.replace(/\s/g, "")}`} className="transition-colors hover:text-brand">
                    {p}
                  </a>
                </p>
              ))}
              {contact.emails.map((e) => (
                <p key={e}>
                  <a href={`mailto:${e}`} className="transition-colors hover:text-brand">
                    {e}
                  </a>
                </p>
              ))}
            </div>
          )}
        </div>
      </div>
      <div className="flex flex-col gap-3 border-t border-white/5 px-6 py-6 font-mono text-[10px] uppercase tracking-[0.15em] text-neutral-600 md:flex-row md:items-center md:justify-between md:px-12 lg:px-20">
        <p>© 2026 Catalyst Petrochem LLP · IEC 0517501902 · GST 07AALFC9514G1ZC</p>
        <Link to="/admin/login" data-testid="footer-admin-link" className="transition-colors hover:text-brand">
          Admin Login
        </Link>
      </div>
    </footer>
  );
}
